module.exports = __webpack_public_path__ + "img/icon_media.a7e5f52.svg";